import { useMemo } from 'react';

import { useSection } from 'src/components/app/context/SectionContext';
import { useReportConfigAllocationCombinationQuery } from 'src/components/reportConfig/hooks/useReportConfigAllocationQuery';

export const useReportConfigMaps = () => {
  const { moduleId } = useSection();
  const { data: reportConfigsData, loading: reportConfigsLoading } =
    useReportConfigAllocationCombinationQuery(moduleId);

  const reportTypes =
    reportConfigsData?.reportConfigCombinations?.content?.reportTypes;
  const fileTypes =
    reportConfigsData?.reportConfigCombinations?.content?.fileTypes;

  const reportNamesPerReportType = useMemo(
    () =>
      Object.fromEntries(
        Object.entries(reportTypes || {}).map(
          ([reportTypeId, namePerFileType]) => [
            reportTypeId,
            // only one file type expected per report type
            Object.values(namePerFileType)?.[0]?.name ?? '',
          ],
        ),
      ),
    [reportTypes],
  );

  const abbreviationPerFileType = useMemo(
    () =>
      Object.fromEntries(
        Object.entries(fileTypes || {}).map(([fileTypeId, fileType]) => [
          fileTypeId,
          fileType.abbreviation ?? '',
        ]),
      ),
    [fileTypes],
  );

  return {
    reportNamesPerReportType,
    abbreviationPerFileType,
    reportConfigsLoading,
  };
};

export default useReportConfigMaps;
